webpackJsonp([1,2],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Message = function Message(text, user) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Message);

  var time = Date.now();

  this.id = user + time;
  this.time = time;
  this.text = text;
  this.user = user;
  this.error = '';
  this.status = false;
};

/* harmony default export */ __webpack_exports__["a"] = Message;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(81)
__webpack_require__(82)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAnswer; });




var ANSWER_URL = '/api/get-answer';
var SERVER_TIME_LATENCY = 600;

var ErrorMessage = function ErrorMessage(response) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ErrorMessage);

  this.ok = false;
  this.error = response.statusText;
};

function timeout(time) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, time);
  });
}

var getAnswer = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(text) {
    var body, response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = new FormData();

            body.set('q', text);

            _context.next = 4;
            return fetch(ANSWER_URL, { method: 'POST', body: body });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return timeout(SERVER_TIME_LATENCY);

          case 7:
            return _context.abrupt('return', response.ok ? response.json() : new ErrorMessage(response));

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getAnswer(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_chat__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    Chat: __WEBPACK_IMPORTED_MODULE_0__components_chat___default.a
  }
};

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      text: ''
    };
  },
  computed: {
    isDisabledButton: function isDisabledButton() {
      return !this.text.trim();
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      this.$emit('submit', this.text.trim());
      this.text = '';
    }
  }
};

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_message__ = __webpack_require__(21);




function leftPad(num) {
  var str = num + '';
  return str.length < 2 ? 0 + str : str;
}

/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    message: {
      type: __WEBPACK_IMPORTED_MODULE_0__helpers_message__["a" /* default */],
      required: true
    }
  },
  computed: {
    time: function time() {
      var date = new Date(this.message.time);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      return leftPad(hours) + ':' + leftPad(minutes) + ':' + leftPad(seconds);
    },
    className: function className() {
      return 'is-' + this.message.user.toLowerCase();
    }
  }
};

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_message__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_chat_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_chat_message__);




/* harmony default export */ __webpack_exports__["default"] = {
  props: {
    messages: {
      type: Array,
      required: true
    }
  },
  updated: function updated() {
    var box = this.$refs.messages;
    box.scrollTop = box.scrollHeight;
  },

  components: {
    ChatMessage: __WEBPACK_IMPORTED_MODULE_0__components_chat_message___default.a
  }
};

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_api__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_message__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_messages__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_chat_messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chat_form__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_chat_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_chat_form__);







/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      user: 'Me',
      messages: []
    };
  },
  methods: {
    onSubmit: function onSubmit(text) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var message, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                message = new __WEBPACK_IMPORTED_MODULE_3__helpers_message__["a" /* default */](text, _this.user);

                _this.messages.push(message);

                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__helpers_api__["a" /* getAnswer */](text);

              case 4:
                response = _context.sent;

                _this.handlerResponse(response, message);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    handlerResponse: function handlerResponse(res, userMessage) {
      this.$set(userMessage, 'status', true);

      if (res.ok) {
        var message = new __WEBPACK_IMPORTED_MODULE_3__helpers_message__["a" /* default */](res.a, 'Server');
        this.messages.push(message);
      } else {
        this.$set(userMessage, 'error', res.error);
      }
    }
  },
  components: {
    ChatMessages: __WEBPACK_IMPORTED_MODULE_4__components_chat_messages___default.a,
    ChatForm: __WEBPACK_IMPORTED_MODULE_5__components_chat_form___default.a
  }
};

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KCTxzdmcgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgoJCWZpbGw9JyNmZmYnIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNTEyIDMzNy42IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KCTxnPgoJCTxwb2x5Z29uIHBvaW50cz0iMCwzMDUuNyA2Mi42LDI3NC45IDY0LjEsNjAgMCwyNy41IAkiLz4KCQk8cGF0aCBkPSJNMjUxLjgsMTA3LjNjMjguNiwwLjIsNTIuMywxOS45LDU5LDQ2LjRsMjAxLjcsMS4zbDAuMi0zMC43TDI2Ny44LDBMMTE0LDYwLjRsLTAuOCwxMjIuOGwtMC42LDkyLjFsMTUzLjEsNjIuNEw1MTIsMjE2LjUKCQkJbDAuMi0zMC43bC0yMDEuNi0xLjNjLTcuMSwyNi40LTMxLDQ1LjgtNTkuNSw0NS43Yy0zMy45LTAuMi02MS4yLTI3LjktNjEtNjEuOEMxOTAuMiwxMzQuNCwyMTcuOSwxMDcuMSwyNTEuOCwxMDcuM3oiLz4KCTwvZz4KPC9zdmc+Cg=="

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(80)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(79)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(84)
__webpack_require__(85)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(83)

var Component = __webpack_require__(7)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-message",
    class: _vm.className
  }, [_c('div', {
    staticClass: "chat-message_user"
  }, [_vm._v(_vm._s(_vm.message.user))]), _c('div', {
    staticClass: "chat-message_text"
  }, [_vm._v(_vm._s(_vm.message.text))]), _c('div', {
    staticClass: "chat-message_time"
  }, [_vm._v(_vm._s(_vm.time))]), _c('div', {
    staticClass: "chat-message_error"
  }, [_vm._v(_vm._s(_vm.message.error))])])
},staticRenderFns: []}

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "chat-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "chat-form_message"
  }, [_vm._v("На одинаковые вопросы будут одинаковые ответы\n")]), _c('img', {
    staticClass: "chat-form_icon-pen",
    attrs: {
      "src": __webpack_require__(89)
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "chat-form_input",
    attrs: {
      "name": "q",
      "type": "text",
      "placeholder": "Введите вопрос",
      "autocomplete": "off",
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "chat-form_button",
    attrs: {
      "type": "submit",
      "disabled": _vm.isDisabledButton
    }
  }, [_vm._v("Узнать ответ")])])
},staticRenderFns: []}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Chat')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat"
  }, [_c('ChatMessages', {
    staticClass: "chat_messages",
    attrs: {
      "messages": _vm.messages
    }
  }), _c('ChatForm', {
    staticClass: "chat_form",
    on: {
      "submit": _vm.onSubmit
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "messages",
    staticClass: "chat-messages"
  }, [_c('transition-group', {
    staticClass: "chat-messages_inner",
    attrs: {
      "name": "messages",
      "tag": "div"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('ChatMessage', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  })), (!_vm.messages.length) ? _c('div', {
    staticClass: "chat-messages_empty"
  }, [_vm._v("Напишите что-нибудь в чат")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

},[100]);


// WEBPACK FOOTER //
// static/js/app.385f6c40a6c47bdab4dc.js